import { RootView } from "../core/modulos/root/root.view"
export var UI_ROOT = "mui"

export function RootRouter(){
    return (
        <RootView />
    )
}